import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", () => {
	const heroSlider = document.querySelector(".hero-slider");

	if (!heroSlider) return;

	const slides = heroSlider.querySelectorAll(".splide__slide");
	const hasMultipleSlides = slides.length > 1;

	// Get CTA values for slider's speed
	function getSpeed(element) {
		if (element.classList.contains("5000")) return 5000;
		if (element.classList.contains("3000")) return 3000;
		if (element.classList.contains("2000")) return 2000;
		return 3000; // Default interval
	}

	// Get ACF values status and assign them to splide options
	let options = {
		speed: getSpeed(heroSlider),
		autoplay: heroSlider.classList.contains("autoplay"),
	};

	new Splide(heroSlider, {
		type: hasMultipleSlides ? "loop" : "slide",
		autoplay: options.autoplay,
		interval: options.speed,
		arrows: false,
		pagination: hasMultipleSlides,
		pauseOnHover: false,
		pauseOnFocus: false,
		speed: 800,
	}).mount();
});
